import {
  CHANGE_ACCEPT_QUANTITY_IAR_CONFIRM,
  FETCH_INVENTORY_ADDITION_DATA_REQUEST,
  FETCH_INVENTORY_ADDITION_DATA_SUCCESS
} from "../constants/actionTypes";
import { createReducer } from "../utils";

const initialState = {
  isFetching: true,
  inventoryRequest: {},
  accepted: 0
};

export const inventoryAdditionRequestReducer = createReducer(initialState, {
  [FETCH_INVENTORY_ADDITION_DATA_REQUEST]: (state, payload) => {
    console.log(payload);
    return {
      ...state,
      ...payload,
      isFetching: true
    };
  },
  [FETCH_INVENTORY_ADDITION_DATA_SUCCESS]: (state, payload) => {
    console.log(payload);
    return {
      ...state,
      ...payload,
      isFetching: false,
      accepted: 0
    };
  },
  [CHANGE_ACCEPT_QUANTITY_IAR_CONFIRM]: (state, payload) => {
    return {
      ...state,
      ...payload
    };
  }
});

export default inventoryAdditionRequestReducer;
